import React, { useState, useEffect } from 'react';
import './LoginPage.css';
import { toast } from 'react-toastify';
import { BASE_URL, loginWithUserName, logUserActivity } from '../../Services/courseService';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext/AuthContext';
import ClipLoader from 'react-spinners/ClipLoader';
import 'react-toastify/dist/ReactToastify.css';
import { GoogleLogin } from '@react-oauth/google';
import login_img from '../../Assets/login.png';
import axios from 'axios';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { ThreeDots } from 'react-loader-spinner';
const LoginPage = () => {
  const navigate = useNavigate();
   const [info, setInfo] = useState({ emailOrPhoneNumber: '', password: '' });
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);
  const [googleAuthLoading, setGoogleAuthLoading] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [submitOtploading, setSubmitOtpLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { t } = useTranslation();
  const [otpInfo, setOtpInfo] = useState({ email: '', otp: '' });
  const [isOtpRequested, setIsOtpRequested] = useState(false);


  useEffect(() => {
    const userId = localStorage.getItem('userId');
    if (userId) {
      navigate('/');
    }
  }, [navigate]);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
  // const handleLogin = async (e) => {
  //   e.preventDefault();
  
  //   toast.dismiss();  
  
  //   setLoading(true);
  
  //   try {
  //     const response = await loginWithUserName(info);
  //     toast.dismiss();
  
  //     if (response?.status === 200) {
  //       toast.success("Logged In successfully!", { autoClose: 3000 });

  //       localStorage.setItem('token', response.data.token);
  //       localStorage.setItem('fullName', response.data.fullname);
  //       localStorage.setItem('email', response.data.email);
  //       localStorage.setItem('phoneNumber', response?.data?.phoneNumber || "Click 'Update Mobile Number' to add your number, as it's not available");
  //       localStorage.setItem('userId', response.data.userId);
  //       localStorage.setItem('profilePictureUrl', response.data.profilePictureUrl);
  
  //       setTimeout(() => navigate('/'), 100); 
  //     } else {
  //       toast.error(response?.data?.message);
  //     }
  //   } catch (error) {
  //     toast.dismiss();
  
  //     if (error?.response?.status === 503) {
  //       toast.error("Service Unavailable. Please try again later.", { autoClose: 3000 });
  //     } else {
  //       toast.error(error.response?.data?.message || 'Network error. Please check your connection and try again.');
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  const handleLogin = async (e) => {
  e.preventDefault();

  toast.dismiss();  
  setLoading(true);

  try {
    const response = await loginWithUserName(info);
    toast.dismiss();

    if (response?.status === 200) {
      toast.success("Logged In successfully!", { autoClose: 3000 });

      localStorage.setItem('token', response.data.token);
      localStorage.setItem('fullName', response.data.fullname);
      localStorage.setItem('email', response.data.email);
      localStorage.setItem('phoneNumber', response?.data?.phoneNumber || "Click 'Update Mobile Number' to add your number, as it's not available");
      localStorage.setItem('userId', response.data.userId);
      localStorage.setItem('profilePictureUrl', response.data.profilePictureUrl);

      // Calling analytics API
      try {
        await logUserActivity(response.data.fullname, "LOGGEDIN");
      } catch (err) {
        console.error("Failed to log activity:", err);
      }

      setTimeout(() => navigate('/'), 100); 
    } else {
      toast.error(response?.data?.message);
    }
  } catch (error) {
    toast.dismiss();

    if (error?.response?.status === 503) {
      toast.error("Service Unavailable. Please try again later.", { autoClose: 3000 });
    } else {
      toast.error(error.response?.data?.message || 'Network error. Please check your connection and try again.');
    }
  } finally {
    setLoading(false);
  }
};

  
  const handleEmailOtpRequest = async () => {
    toast.dismiss();

    if (!otpInfo.email) {
      toast.error('Please enter your email to receive OTP.');
      return;
    }

    if (!emailRegex.test(otpInfo.email)) {
      toast.error('Invalid email format', { autoClose: 3000 });
      return;
    }

    setOtpLoading(true);
    try {
      const response = await axios.post(`${BASE_URL}/requestEmailOtp?email=${otpInfo.email}`);
      if (response.status === 200) {
        toast.dismiss();

        toast.success(response?.data?.message || 'OTP sent to your email.');
        setIsOtpRequested(true);
      }
    }
    catch (error) {
      toast.dismiss();

      toast.error(error.response?.data?.message || 'Error sending OTP. Please try again.');
    }
    finally {
      setOtpLoading(false);

    }
  }

  const handleValidateEmailOtp = async (e) => {
    e.preventDefault();
    toast.dismiss();

    if (!otpInfo.otp) {
      toast.error('Please enter OTP.');
      return;
    }

    setSubmitOtpLoading(true);

    try {
      const response = await axios.post(`${BASE_URL}/validateEmailOtp`, {
        email: otpInfo.email,
        otp: otpInfo.otp
      })

      if (response.status === 200) {
        toast.dismiss();

        toast.success("Logged In successfully!", { autoClose: 3000 });
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('fullName', response.data.fullname);
        localStorage.setItem('email', response.data.email);
        localStorage.setItem('phoneNumber', response?.data?.phoneNumber || "Click 'Update Mobile Number' to add your number, as it's not available");
        localStorage.setItem('userId', response.data.userId);
        localStorage.setItem('profilePictureUrl', response.data.profilePictureUrl);

        login();
        navigate('/');
      }
      else {
        toast.dismiss();

        toast.error(response?.data);
      }
    } catch (error) {
      toast.dismiss();

      toast.error(error.response?.data?.message || 'Invalid OTP or OTP expired. Please try again.');
    }
    finally {
      setSubmitOtpLoading(false);
    }
  }

   

  const handleGoogleLogin = async (response) => {
    const token = response.credential;
    toast.dismiss();

    try {
      setGoogleAuthLoading(true);
      const response = await axios.post(`${BASE_URL}/google/login`, { token: token, userType: "Student" });
      if (response?.status === 200) {
        toast.dismiss();

              try {
        await logUserActivity(response.data.fullname, "LOGGED IN THROUGH GOOGLE");
      } catch (err) {
        console.error("Failed to log activity:", err);
      }


        toast.success("Logged In successfully!", { autoClose: 3000 });
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('fullName', response.data.fullname);
        localStorage.setItem('email', response.data.email);
        localStorage.setItem('phoneNumber', response?.data?.phoneNumber || "Click 'Update Mobile Number' to add your number, as it's not available");
        localStorage.setItem('userId', response.data.userId);
        localStorage.setItem('userType', response.data.userType);
        localStorage.setItem('profilePictureUrl', response.data.profilePictureUrl);

        navigate('/');
      } else {
        toast.success(response?.data?.message);
      }

    } catch (error) {
      toast.dismiss();

      if (error?.response?.status === 503) {
        toast.error("Service Unavailable. Please try again later.", { autoClose: 3000 });
      } else {
        toast.error('There was an issue connecting. Please try again, or use normal login/registration.');
      }
    } finally {
      setGoogleAuthLoading(false);
    }
  };


  const handleGoogleLoginFailure = (error) => {
    toast.error('Google login failed. Please try again.', { autoClose: 3000 });
  };




  return (
    <div className="main-login-container">

      <div className="login-container">
        <div className="login-form">
          <h2>{t('Login')}</h2>
          <p>{t('Login to access your skillzverse account')}</p>
          {!isOtpRequested ? (
            <form onSubmit={handleLogin}>
              <div className="password-input-container">
                <input
                  type="text"
                  placeholder={t('Email')}
                  value={info.emailOrPhoneNumber}
                  onChange={(e) => setInfo({ ...info, emailOrPhoneNumber: e.target.value.toLowerCase() })}
                />
              </div>
              <div className="password-input-container">
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder={t('Password')}
                  value={info.password}
                  onChange={(e) => setInfo({ ...info, password: e.target.value })}
                />
                <span className="password-toggle" onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <FiEyeOff /> : <FiEye />}
                </span>
              </div>
              <a className='forgot-password-btn' href="/forgot-password">{t('Forgot Password')}</a>
              {/* <div className="checkbox-container">
                <label>
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={() => setIsChecked(!isChecked)}
                  />
                  {t('I agree to the')} <a href="/terms-conditions" target="_blank">Terms and Conditions</a> & <a href="/privacy-policy" target="_blank">Privacy Policy</a>.
                </label>
              </div> */}
              <button type="submit" className="submit-button" disabled={loading}>
                {loading ? <ClipLoader color="#fff" loading={loading} size={30} /> : t('Login')}
              </button>
              <span className='forgot-password-btn2' onClick={() => setIsOtpRequested(true)}>
                {t('Login with OTP')}
              </span>
            </form>
          ) : (
            <form onSubmit={handleValidateEmailOtp}>
              <div className="password-input-container">
                <input
                  type="email"
                  placeholder={t('Email')}
                  value={otpInfo.email}
                  onChange={(e) => setOtpInfo({ ...otpInfo, email: e.target.value })}
                />
              </div>
              <span className='forgot-password-btn3' onClick={handleEmailOtpRequest}>
                {
                  otpLoading ? <ThreeDots color="black" height={20} width={40} /> :t('Send OTP')
                }
              </span>
              <div className="password-input-container">
                <input
                  type="text"
                  placeholder={t("Enter OTP")}
                  value={otpInfo.otp}
                  onChange={(e) => setOtpInfo({ ...otpInfo, otp: e.target.value })}
                />
              </div>
              <button type="submit" className="submit-button" disabled={submitOtploading}>
                {submitOtploading ? <ClipLoader color="#fff" loading={submitOtploading} size={30} /> : t('Submit OTP')}
              </button>
              <span className='forgot-password-btn2' onClick={() => setIsOtpRequested(false)}>
                {t('Login with Password')}
              </span>
            </form>
          )}
          <div className="login-options">
            {t('Don’t have an account?')}
            <a href="/register"> {t('Sign up')}</a>
          </div>
          <div className="divider">
            <hr />
            <span>{t('Or login with')}</span>
            <hr />
          </div>
          <div className="social-icons">
            <div className="google-icon">
              <GoogleLogin
                onSuccess={handleGoogleLogin}
                onFailure={handleGoogleLoginFailure}
                scope="profile email"
                responseType="token id_token"
                useOneTap
              />
            </div>
          </div>
        </div>
      </div>

      <div className='image-container'>
        <link rel="preload" href={login_img} as="image" />

        <img src={login_img} alt="Student" className="login-image" />

      </div>

      {(googleAuthLoading) && (
        <div className='loading-container'>
          <div className="loading-overlay">
            <ClipLoader color="black" loading={googleAuthLoading} size={30} />
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginPage;
